﻿import { products } from '../Endpoints'
import { parseDate } from "../../../../../Resources/Scripts/_Shared/parseDate";

export const useOrderLines = async (formData) => {
  const emptyGuid = '00000000-0000-0000-0000-000000000000';
  const lang = document.querySelector('html').getAttribute('lang');

  const BillingFrequency = formData?.paymentSelection?.item?.value;

  const selectedDate = formData?.date?.date ?? "";
  const StartDate = selectedDate ? new Date(parseDate(selectedDate, 'sv', 'L')).toISOString() : "";

  const isReserved = formData?.productSelection.item.Type === 'RESERVED';

  const ParkingSpaceUids = formData?.spotSelection?.length && formData.spotSelection[0].item?.ParkingSpace?.Uid !== emptyGuid ? formData?.spotSelection?.map((spot) => spot?.item?.ParkingSpace?.Uid ?? null) : null;
  const PmcId = formData?.productSelection?.item?.Id;
  const Quantity = isReserved && ParkingSpaceUids ? ParkingSpaceUids.length : formData?.numberOfParkingSpots?.number ?? 0;

  const createSalesOrderParams = {
    StartDate, PmcId, Quantity, BillingFrequency, ...(ParkingSpaceUids && { ParkingSpaceUids })
  };

  const response = await products.createSalesOrderDraft(createSalesOrderParams, false, lang);

  return response
}